import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { map, switchMap } from 'rxjs/operators';
import { EPEmployeeService } from 'src/app/services/EmployerPortalServices/ep-employee.service';

@Injectable()
export class NewEmployeeViewEffects {
  constructor(private actions$: Actions,
    private service: EPEmployeeService) {
  }

  getData$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestAction),
    switchMap((action: any) => this.service.getNewEmployee(action.id)),
    map((data: any) => {
      return ActionsList.ResponseAction({ payload: data.data });
    })
  ));
}
